import React from 'react';

interface NoMarginH4Props {
  children: React.ReactNode;
}
// Utility component to remove margin from h4 elements
const NoMarginH4 = ({ children }: NoMarginH4Props) => (
  <h4 className="m-0">{children}</h4>
);

export default NoMarginH4;
